export default __webpack_public_path__ + "static/media/mofoluwasho.b2c7c832.png";